/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import '../styles/AddressBlock.css'
import ToolTip from '../../../../../../common/ToolTip/ToolTip'

/**
 *     Import
 *     - Components
 */
import { MarkerIcon } from '../../../../../../../images/icons/Marker/Marker'
import AddressNew from './AddressNew'
import { AddressDetails } from './AddressDetails'
import AddressSecurity from './AddressSecurity'

export default class AddressBlock extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            content: this.props.newAddress || this.props.setSecurity || null,
            address: null,
            isNewAddress: false,
        }
    }

    /**
     * Toggle the content to Security check component
     */
    toggleContent = (address: any) => {
        if (address.riskLocation &&
            address.riskLocation.addressType !== 'home' &&
            address.riskLocation.addressType !== 'office' &&
            address.riskLocation.addressType !== 'storage location' &&
            address.riskLocation.addressType !== 'retail location') {
            this.handleNewAddress(address)
        } else {
            this.setState({
                content: false,
                address: address,
            })
            this.props.openedNewAddress()
        }
    }

    /**
     * Trigger the action function to create a new address
     * @param  {object} address  [Object with the riskAdress details]
     */
    handleNewAddress = (address: any) => {
        this.props.createNewAddress(address)
    }

    /**
     * Handle the cancel button action on address blocks
     */
    handleCancel = (newAddressForced: any) => {
        this.setState({
            content: null,
        })
        if (!newAddressForced) {
            newAddressForced = false
        }
        this.props.handleCancel(newAddressForced)
    }

    /**
     * Call the deleteLocation function to trigger te delete action
     * @param  {number} id  [Address ID]
     */
    handleDelete = (id: number) => {
        this.props.deleteLocation(id)
    }

    render() {
        const { newAddress, mta, editQuote } = this.props
        const { content, address } = this.state
        return (
            <div
                className={
                    `addressBlock ${(newAddress || content === false) ?
                        'addressBlock--new' : 'addressBlock--list'} ${(mta || editQuote) ?
                            'MtaNewAddress' : ''}`}
            >
                <div className="addressBlock__container">

                    <div
                        className={
                            `${(newAddress || (mta || editQuote)) ? 'address_tool_tip' : ''} 
                    addressBlock__title`}
                    >
                        <h4>{newAddress ? 'Add a risk address' : 'Address'}</h4>
                        {newAddress ?
                            <div className="inline__icon">
                                <ToolTip position="left">
                                    For Museums or Storage Facilities not listed.
                                    Please use the "Office, Home or Other"
                                    category to complete the required security details
                                </ToolTip>
                            </div> : null}
                        {(mta || editQuote) && newAddress ?
                            null :
                            <div className="addressBlock__marker">
                                <MarkerIcon />
                            </div>}
                    </div>

                    {ContentSwitch(
                        content,
                        this.props,
                        this.handleNewAddress,
                        this.toggleContent,
                        this.handleDelete,
                        this.handleCancel,
                        address
                    )}

                </div>
            </div>
        )
    }
}

/**
 * Content switcher to set the content of this block
 */
const ContentSwitch = (
    opt, props, handleNewAddress, triggerVerify, triggerDelete, handleCancel, address) => {

    const {
        temp_id,
        initial_address,
        addressType,
        addressLine1,
        addressLine2,
        city,
        postcode,
        addLocationsSecurity,
        updateMtaLocations,
        securityVerified,
        id,
        quoteId,
        hideDeleteLocation,
        countryName,
        fetchOccupancies,
        occupancies,
    } = props || ''

    switch (opt) {
        case true:
            return (
                <AddressNew
                    createNewAddress={props.createNewAddress}
                    handleCancel={handleCancel}
                    toggleContent={triggerVerify}
                    getLatLongTrigger={props.getLatLongTrigger}
                    isCollectors={props.isCollectors}
                    isMuseums={props.isMuseums}
                    isDealersStock={props.isDealersStock}
                    isWineSpirits={props.isWineSpirits}
                    isCommercialProperty={props.isCommercialProperty}
                    countries={props.countries}
                    isMTA={props.mta}
                />
            )

        case false:
            return (
                <AddressSecurity
                    handleCancel={handleCancel}
                    addLocationsSecurity={addLocationsSecurity}
                    updateMtaLocations={updateMtaLocations}
                    addressId={id}
                    quoteId={quoteId}
                    address={address}
                    handleNewAddress={handleNewAddress}
                    isCollectors={props.isCollectors}
                    isMuseums={props.isMuseums}
                    isDealersStock={props.isDealersStock}
                    isWineSpirits={props.isWineSpirits}
                    isCommercialProperty={props.isCommercialProperty}
                    updateDirty={props.updateDirty}
                    fetchOccupancies={fetchOccupancies}
                    occupancies={occupancies}
                    editQuote={props.mta || props.editQuote}
                    isMTA={props.mta}
                    propertyData={props.propertyData}
                    temp_id={temp_id}
                    initial_address={initial_address}
                />
            )

        default:
            return (
                <AddressDetails
                    id={id}
                    addressType={addressType}
                    addressLine1={addressLine1}
                    addressLine2={addressLine2}
                    city={city}
                    postcode={postcode}
                    securityVerified={securityVerified}
                    triggerVerify={triggerVerify}
                    triggerDelete={triggerDelete}
                    hideDeleteLocation={hideDeleteLocation}
                    countries={props.countries}
                    addressAllocated={props.addressAllocated}
                    countryName={countryName}
                    isMTA={props.mta}
                    temp_id={temp_id}
                    initial_address={initial_address}
                />
            )

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/components/Step02cp/components/AddressBlock.tsx